// Rules both PRF pages apply before sending an approval or a rejection.

export const REJECTION_COMMENT_REQUIRED = 'Please say why you are rejecting this Pursuit Request Form.';

/**
 * Returns the reason an approval action cannot be sent, or null when it can.
 *
 * A rejection has to give a reason: the creator only ever sees the comment to know what to fix,
 * and a rejected PRF cannot be reopened. Approvals may be silent.
 *
 * @param {string} action 'approve' or 'reject'.
 * @param {string} comment the comment entered, which may be undefined when the field is absent.
 * @returns {string|null} the refusal reason, or null.
 */
export const approvalRefusalReason = (action, comment) => {
    if (action === 'reject' && !(comment || '').trim()) {
        return REJECTION_COMMENT_REQUIRED;
    }

    return null;
};
